import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import { api } from '../lib/api';

function TestimonialCard({ item }) {
    return (
        <div className="testimonial-marquee__card">
            <div className="testimonial-marquee__stars">
                {[1, 2, 3, 4, 5].map((s) => (
                    <Star
                        key={s}
                        size={12}
                        fill={s <= (item.rating || 5) ? 'var(--amber)' : 'transparent'}
                        color="var(--amber)"
                    />
                ))}
            </div>
            <p className="testimonial-marquee__quote">"{item.quote}"</p>
            <div className="testimonial-marquee__author">{item.author_name}</div>
            <div className="testimonial-marquee__role">{item.author_role}</div>
        </div>
    );
}

export function TestimonialMarquee() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        api.get('/public/testimonials')
            .then((r) => setItems(r.data.items || []))
            .catch(() => setItems([]));
    }, []);

    if (items.length === 0) return null;

    const loop = [...items, ...items];

    return (
        <section className="testimonial-marquee-section" data-testid="testimonial-marquee">
            <div className="container-x">
                <div className="testimonial-marquee-section__head">
                    <div className="kicker">Voci de la masă</div>
                    <h2 className="headline testimonial-marquee-section__title">
                        Restauratori care ne recomandă.
                    </h2>
                </div>
            </div>
            <div className="testimonial-marquee" aria-label="Testimoniale clienți">
                <div className="testimonial-marquee__track">
                    {loop.map((item, i) => (
                        <TestimonialCard key={`${item.id}-${i}`} item={item} />
                    ))}
                </div>
            </div>
        </section>
    );
}
